export enum LoanComputationMode {
  VariableRepaymentTypeLoan,
  EmiRepaymentTypeLoan,
}
